import React from "react";
import "./Rules_card.css";

function Rules_card() {
  return (
    <>
      <section className="Rules_card">
        <div className="rules_section">
          <div className="heading_bg_holder">
            <div className="img_holder">
              <img
                src="/assets/images/Invitation_Reward_Rules/heading_bg.png"
                className="bg_img"
                alt="bg"
              />
            </div>
            <div className="rules_title">
              <p>Rules</p>
            </div>
          </div>
          <p>
            There are 6 subordinate levels in inviting friends. If A invites B,
            then B is a level 1 subordinate of A. If B invites C, then C is a
            level 1 subordinate of B and level 2 of A.
          </p>
        </div>
      </section>
    </>
  );
}

export default Rules_card;
